export const RESET_PASS_VIEW_FORM_FIELDS = {
  Password: 'password',
  PasswordConfirmation: 'passwordConfirmation',
} as const;

export type ResetPassViewFormValues = {
  [RESET_PASS_VIEW_FORM_FIELDS.Password]: string;
  [RESET_PASS_VIEW_FORM_FIELDS.PasswordConfirmation]: string;
};
